module.exports = __webpack_public_path__ + "img/easy.10d88191.png";